import { getRequestWithToken } from '.';
import Toast from '../utils/toast';

const Faq = async payload => {
  try {
    const faqPath = `/faq`;
    return await getRequestWithToken(faqPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const Testimonials = async payload => {
  try {
    const faqPath = `/testimonials`;
    return await getRequestWithToken(faqPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

const Setting = async payload => {
  try {
    const settingPath = `/setting`;
    return await getRequestWithToken(settingPath, payload);
  } catch (error) {
    Toast('error', error?.response?.data?.message);
  }
};

export const homePageService = {
  Faq,
  Testimonials,
  Setting
};
